/* eslint-disable react/button-has-type */
/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from "react";
import { formatPhoneNumber } from "utils/regexPhone";
import { IconButton, Menu, MenuItem, Tooltip } from "@mui/material";
import { DataResponse } from "services/api/AppWeb_Lead/dados-basicos";
import SliderTemperature from "components/sliderTemperature";
import { AtualizadoBar } from "components/atualizadoBar";
import moment from "moment";
import icons from "constants/icons";
import { RootStateOrAny, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { MdOutlineModeEditOutline } from "react-icons/md";
import { getEtiquetas } from "services/api/AppWeb_Lead/listar-etiquetas";
import { useWhatsAppStatus } from "services/api/AppWeb_WhatsApp/useWhatsAppStatus";
import { LiaTagSolid } from "react-icons/lia";
import { TagEditor } from "components/dialogCommon/templates/tagEditor";
import { postEtiquetaLead } from "services/api/AppWeb_Lead/alterar-etiqueta-lead";
import { CARGO_CODES } from "constants/permissions";
import { RenderByCargo } from "utils/RenderByCargo";
import { IoMdUndo } from "react-icons/io";
import * as Styles from "./styles";
import OutlookImage from "../../../assets/images/outlookImage.png";
import * as IconsSVG from "../../../assets/iconsSVG";
import { AuthState } from "../../../store/ducks/auth/types";
import { useIdentificaCliente } from "../../../services/api/AppWeb_Lead/alterar-identifica-cliente";
import { DadosComplementares } from "../../../components/dialogCommon/templates/dadosComplementares";
import DialogCommon from "../../../components/dialogCommon";
import visitouIcon from "../../../assets/icons/visitouIcon.png";

interface DadosGeraisInterface {
  title: string;
  outcome: string;
  tooltip: string;
}

interface Props {
  openModalDadosComplementares: () => void;
  openModalPhones: () => void;
  openModalEmails: () => void;
  openModalName: () => void;
  openModalOfertas: () => void;
  openModalOrigem: () => void;
  openWhatsAppModal: (phone: string) => void;
  onUpdateClick: () => void;
  dataLead: DataResponse | undefined;
  refetch: () => void;
  readOnly?: boolean;
}

export function DadosBasicosHeader(props: Props) {
  const { codigoCargo2013 } = useSelector<RootStateOrAny, AuthState>(
    (state) => state.user
  );
  const { data: tags, refetch: refetchEtiquetas } = getEtiquetas();
  const { data: whatsStatusData } = useWhatsAppStatus();
  const isWhatsConnected = whatsStatusData?.data?.conectado === true;
  const [identificaCliente, setIdentificaCliente] = useState(false);
  const [dadosComplementares, setDadosComplementares] = useState(false);
  const [tagsOpen, setTagsOpen] = useState(false);
  const [openEditing, setOpenEditing] = useState<string | undefined>(undefined);
  const [anchorElEtiqueta, setAnchorElEtiqueta] = useState(null);
  const openEtiqueta = Boolean(anchorElEtiqueta);
  const [confirmEtiqueta, setConfirmEtiqueta] = useState(false);
  const isCorretor =
    codigoCargo2013 === "219.840.002" ||
    codigoCargo2013 === "219.840.012" ||
    codigoCargo2013 === "219.840.001";
  const isGerente =
    codigoCargo2013 === CARGO_CODES.GERENTE_VENDAS ||
    codigoCargo2013 === CARGO_CODES.GERENTE_GERAL ||
    codigoCargo2013 === CARGO_CODES.GERENTE_CIA;
  const attDate = new Date(props.dataLead?.dataCriacao || "");
  const dateTime = props.dataLead?.dataCriacao.split(" ");
  const dataCriacaoFormatted = `${moment(attDate)?.format("DD/MM/YYYY")} às ${
    dateTime ? dateTime[1] : "--"
  }`;
  const produtoOrigem = props.dataLead?.produtoOrigem ?? "--";
  const produtoOrigemFormatted =
    produtoOrigem?.length > 20
      ? `${produtoOrigem?.slice(0, 20)} ...`
      : produtoOrigem;
  const dadosGerais: DadosGeraisInterface[] = [
    {
      title: "Origem",
      outcome: props.dataLead?.origemLead || "--",
      tooltip: props.dataLead?.origemLead || "--",
    },
    {
      title: "Canal",
      outcome: props.dataLead?.canal || "--",
      tooltip: props.dataLead?.canal || "--",
    },
    {
      title: "Produto de origem",
      outcome: produtoOrigemFormatted,
      tooltip: produtoOrigem,
    },
    {
      title: "Etapa",
      outcome: props.dataLead?.etapaLead || "--",
      tooltip: props.dataLead?.etapaLead || "--",
    },
    {
      title: "Data de cadastro",
      outcome: dataCriacaoFormatted || "--",
      tooltip: dataCriacaoFormatted || "--",
    },
  ];
  const [outputDate, setOutputDate] = React.useState<string | undefined>(
    undefined
  );
  React.useEffect(() => {
    if (props.dataLead?.dataUltimaAtualizacao) {
      const inputDateObj = new Date(props.dataLead?.dataUltimaAtualizacao);
      setOutputDate(inputDateObj.toISOString().slice(0, 19).replace("T", " "));
    }
  }, [props.dataLead?.dataUltimaAtualizacao]);

  const handleTagsOpen = () => {
    setAnchorElEtiqueta(null);
    if (!tagsOpen) setTagsOpen(true);
  };

  const handleEtiqueta = (event: any) => {
    setAnchorElEtiqueta(event.currentTarget);
  };

  const handleChangeEtiqueta = (idEtiqueta: string) => {
    setAnchorElEtiqueta(null);

    postEtiquetaLead({
      idLeadCorretor: props?.dataLead?.idLeadCorretor as string,
      idEtiqueta,
    })
      .then(({ success, data }) => {
        if (success) {
          toast.success(data);
          props.refetch();
        } else {
          throw new Error();
        }
      })
      .catch((err) => {
        console.error(err);
        toast.error("Erro ao alterar etiqueta");
      });
  };

  const selecionarTelefone = () => {
    switch (props?.dataLead?.codigoTelefonePrincipal) {
      case 1:
        return props?.dataLead?.telefone1
          ? formatPhoneNumber(props?.dataLead?.telefone1)
          : "--";
      case 2:
        return props?.dataLead?.telefone2
          ? formatPhoneNumber(props?.dataLead?.telefone2)
          : "--";
      case 3:
        return props?.dataLead?.telefone3
          ? formatPhoneNumber(props?.dataLead?.telefone3)
          : "--";
      default:
        return "--";
    }
  };

  const selecionarEmail = () => {
    switch (props?.dataLead?.codigoEmailPrincipal) {
      case 1:
        return props.dataLead?.email1?.length > 30
          ? `${props.dataLead?.email1?.slice(0, 30)}...`
          : props.dataLead?.email1 || "--";
      case 2:
        return props.dataLead?.email2?.length > 30
          ? `${props.dataLead?.email2?.slice(0, 30)}...`
          : props.dataLead?.email2 || "--";
      case 3:
        return props.dataLead?.email3?.length > 30
          ? `${props.dataLead?.email3?.slice(0, 30)}...`
          : props.dataLead?.email3 || "--";
      default:
        return props.dataLead?.email1
          ? props.dataLead?.email1?.length > 30
            ? `${props.dataLead?.email1?.slice(0, 30)}...`
            : props.dataLead?.email1
          : "--";
    }
  };

  const copyToClipboard = async (text: string, type: "phone" | "email") => {
    try {
      await navigator.clipboard.writeText(text);
      if (type === "phone") {
        toast.success(`O telefone ${text} foi copiado`, { autoClose: 5000 });
      }
      if (type === "email") {
        toast.success(`O email ${text} foi copiado`, { autoClose: 5000 });
      }
    } catch (err) {
      console.log("Falha ao copiar o texto", err);
    }
  };

  const handleOpenWhatsAppConversation = () => {
    const selectedPhone = selecionarTelefone();
    const normalizedPhone = selectedPhone.replace(/\D/g, "");

    if (!selectedPhone || selectedPhone === "--" || !normalizedPhone) {
      toast.info("Este lead não possui telefone principal para WhatsApp.");
      return;
    }

    // Se a feature de WhatsApp não estiver conectada, redireciona para o
    // WhatsApp externo (wa.me/numero) em vez de abrir o modal interno.
    // O número já vem com DDI da API, então é usado como está.
    if (!isWhatsConnected) {
      window.open(
        `https://wa.me/${normalizedPhone}`,
        "_blank",
        "noopener,noreferrer"
      );
      return;
    }

    props.openWhatsAppModal(selectedPhone);
  };

  const handleCopyPhoneLabel = () => {
    const selectedPhone = selecionarTelefone();
    const normalizedPhone = selectedPhone.replace(/\D/g, "");

    if (!selectedPhone || selectedPhone === "--" || !normalizedPhone) {
      toast.info("Este lead não possui telefone para copiar.");
      return;
    }

    copyToClipboard(selectedPhone, "phone");
  };

  useEffect(() => {
    setIdentificaCliente(
      props?.dataLead?.identificaCliente
        ? props?.dataLead?.identificaCliente
        : false
    );
  }, [props?.dataLead?.identificaCliente]);

  const params = {
    idLead: props?.dataLead?.idLead ? props?.dataLead?.idLead : "",
    identificaCliente: !identificaCliente,
  };

  const { mutate, isSuccess } = useIdentificaCliente({
    idLeadCorretor: props?.dataLead?.idLeadCorretor
      ? props?.dataLead?.idLeadCorretor
      : "",
    body: params,
  });

  useEffect(() => {
    if (isSuccess) {
      setIdentificaCliente(!identificaCliente);
      props?.refetch();
    }
  }, [isSuccess]);

  function counterEmailOrWhats(item2: string, item3: string) {
    const counterMail2 = item2?.length > 0 ? 1 : 0;
    const counterMail3 = item3?.length > 0 ? 1 : 0;
    return counterMail2 + counterMail3 > 0
      ? `+${counterMail2 + counterMail3}`
      : "";
  }

  const MenuEtiqueta = () => (
    <Menu
      anchorEl={anchorElEtiqueta}
      open={openEtiqueta}
      onClose={() => setAnchorElEtiqueta(null)}
    >
      {props?.dataLead?.etiqueta && (
        <MenuItem
          onClick={() => handleChangeEtiqueta("")}
          style={{ fontFamily: "Inter", fontSize: "14px" }}
        >
          <p>Sem etiqueta</p>
        </MenuItem>
      )}
      {tags?.etiquetasCorretor?.map(
        (item: { id: string; nome: string; cor: string }) => (
          <MenuItem
            onClick={() => handleChangeEtiqueta(item?.id)}
            key={item?.id}
            style={{ fontFamily: "Inter", fontSize: "14px" }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "flex-start",
                width: "100%",
              }}
            >
              <p
                style={{
                  padding: "2px 6px",
                  backgroundColor: item?.cor ?? "gray",
                  color: "white",
                  width: "fit-content",
                  maxWidth: "65px",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  fontSize: 12,
                  borderRadius: 8,
                }}
              >
                {item?.nome}
              </p>
            </div>
          </MenuItem>
        )
      )}
      {!props?.dataLead?.etiqueta && (
        <MenuItem
          onClick={handleTagsOpen}
          style={{ fontFamily: "Inter", fontSize: "14px" }}
        >
          <p
            style={{
              color: "#2D5BFF",
              fontWeight: 500,
              textDecoration: "underline",
            }}
          >
            Criar etiqueta
          </p>
        </MenuItem>
      )}
    </Menu>
  );

  return (
    <>
      <Styles.Container>
        <Styles.HeaderInfo>
          <Styles.HeaderInfoLeft>
            <div className="first-section">
              <div style={{ display: "flex", alignItems: "center", gap: 30 }}>
                <Styles.TextHeaderInfo>
                  <Tooltip
                    title={identificaCliente ? "Já é cliente" : "Não comprou"}
                    placement="top"
                    followCursor
                    arrow
                  >
                    <IconButton
                      disabled={props.readOnly}
                      onClick={() =>
                        isCorretor && !props.readOnly ? mutate() : undefined
                      }
                      style={{ marginLeft: -10 }}
                    >
                      {identificaCliente ? (
                        <IconsSVG.BlueMedal />
                      ) : (
                        <IconsSVG.MedalGrey />
                      )}
                    </IconButton>
                  </Tooltip>
                  {props.dataLead?.nomeLead ? (
                    <Styles.Row>
                      <Tooltip
                        title={props.dataLead?.nomeLead}
                        placement="top"
                        arrow
                      >
                        <h2>
                          {props.dataLead?.nomeLead?.length > 15
                            ? `${props.dataLead?.nomeLead?.slice(0, 15)}...`
                            : props.dataLead?.nomeLead}
                        </h2>
                      </Tooltip>
                      {isCorretor && !props.readOnly ? (
                        <IconButton onClick={props?.openModalName}>
                          <IconsSVG.EditIcon fill="#303030" />
                        </IconButton>
                      ) : null}
                    </Styles.Row>
                  ) : (
                    <>
                      <p>--</p>
                    </>
                  )}
                </Styles.TextHeaderInfo>
                {props.dataLead?.proprio === true ? (
                  <RenderByCargo
                    cargo={codigoCargo2013}
                    isCorretor={
                      <>
                        <Styles.EtiquetaContainer>
                          <h2>Etiqueta</h2>
                          {props?.dataLead?.etiqueta ? (
                            <div className="row">
                              <Styles.Etiqueta
                                color={props?.dataLead?.etiqueta?.cor ?? "gray"}
                              >
                                {props?.dataLead?.etiqueta?.nome ?? "--"}
                                <MdOutlineModeEditOutline
                                  size={14}
                                  className="icons"
                                  style={{ marginLeft: 4 }}
                                  onClick={() => {
                                    setOpenEditing(
                                      props?.dataLead?.etiqueta?.id as string
                                    );
                                    setTagsOpen(true);
                                  }}
                                />
                              </Styles.Etiqueta>
                              <div className="arrow">
                                <IconsSVG.ArrowDownIcon
                                  onClick={handleEtiqueta}
                                />
                              </div>
                            </div>
                          ) : (
                            <div className="row">
                              <button
                                type="button"
                                className="add"
                                onClick={handleEtiqueta}
                              >
                                <LiaTagSolid color="#2D5BFF" size={14} />
                                Adicionar etiqueta
                              </button>
                            </div>
                          )}
                          <MenuEtiqueta />
                        </Styles.EtiquetaContainer>
                      </>
                    }
                  />
                ) : null}
              </div>
              <Styles.VisitouContainer>
                {props?.dataLead?.visitou ? (
                  <img src={visitouIcon} alt="Visitou" width={70} height={70} />
                ) : null}
              </Styles.VisitouContainer>
              {isGerente ? (
                <>
                  <Styles.OfertaAtivaButton
                    onClick={() => props.openModalOfertas()}
                  >
                    <IconsSVG.SpeakerIcon />
                    <span>Oferta Ativa</span>
                    <Styles.BadgeCount>
                      {props?.dataLead?.qtdOfertaAtiva || "--"}
                    </Styles.BadgeCount>
                    <IconsSVG.ArrowRight
                      width={24}
                      height={24}
                      color="#00000099"
                    />
                  </Styles.OfertaAtivaButton>
                </>
              ) : null}
              <Tooltip
                title="Código do lead"
                placement="top"
                followCursor
                arrow
              >
                <Styles.Tag>
                  <p>{props.dataLead?.codigoLeadCrm2013 || "--"}</p>
                </Styles.Tag>
              </Tooltip>
              {!props.readOnly && (
                <Styles.AtualizarLeadButton onClick={props.onUpdateClick}>
                  Atualizar Lead
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 41 40"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill="white"
                      d="m16.697 10.058-2.336 2.336L21.95 20l-7.59 7.606 2.337 2.336L26.639 20l-9.942-9.942Z"
                    />
                  </svg>
                </Styles.AtualizarLeadButton>
              )}
            </div>
            <div className="second-section">
              <Styles.ContactArea>
                <p>Telefone</p>
                <div style={{ display: "flex", gap: 8 }}>
                  <Tooltip
                    title={
                      isWhatsConnected
                        ? "Abrir conversa do WhatsApp"
                        : "Abrir no WhatsApp"
                    }
                    placement="top"
                    arrow
                  >
                    <Styles.Pressable onClick={handleOpenWhatsAppConversation}>
                      <IconsSVG.WhatsappIcon />
                    </Styles.Pressable>
                  </Tooltip>

                  <Tooltip title="Copiar número" placement="top" arrow>
                    <Styles.Pressable
                      style={{ minWidth: "150px" }}
                      onClick={handleCopyPhoneLabel}
                    >
                      <p>{selecionarTelefone()}</p>
                    </Styles.Pressable>
                  </Tooltip>

                  {!props.readOnly && (
                    <Tooltip
                      title="Visualizar"
                      placement="top"
                      followCursor
                      arrow
                    >
                      <Styles.Img
                        onClick={() => props.openModalPhones()}
                        width={20}
                        style={{ cursor: "pointer" }}
                        src={icons.plusGreenIcon}
                      />
                    </Tooltip>
                  )}
                  <p>
                    {counterEmailOrWhats(
                      props.dataLead?.telefone2 || "",
                      props.dataLead?.telefone3 || ""
                    )}
                  </p>
                </div>
              </Styles.ContactArea>
              <Styles.ContactArea>
                <p>Email</p>
                <div style={{ display: "flex", gap: 8 }}>
                  <a
                    href={`mailto: ${props.dataLead?.email1}`}
                    target="_blank"
                    rel="noreferrer"
                    aria-label="Enviar e-mail para o lead"
                  >
                    <img
                      src={OutlookImage}
                      alt="Ýcone do Outlook"
                      style={{ width: 20, height: 20 }}
                    />
                  </a>
                  {props.dataLead?.email1 ? (
                    <>
                      <Tooltip title={selecionarEmail()} placement="top" arrow>
                        <Styles.Pressable
                          onClick={() =>
                            copyToClipboard(selecionarEmail(), "email")
                          }
                        >
                          <p>{selecionarEmail()}</p>
                        </Styles.Pressable>
                      </Tooltip>
                      {!props.readOnly && (
                        <Tooltip
                          title="Visualizar"
                          placement="top"
                          followCursor
                          arrow
                        >
                          <Styles.Img
                            onClick={() => props.openModalEmails()}
                            width={20}
                            style={{ marginLeft: 30, cursor: "pointer" }}
                            src={icons.plusGreenIcon}
                          />
                        </Tooltip>
                      )}
                      <p>
                        {counterEmailOrWhats(
                          props.dataLead?.email2,
                          props.dataLead?.email3
                        )}
                      </p>
                    </>
                  ) : (
                    <>
                      <p>--</p>
                      {!props.readOnly && (
                        <Tooltip
                          title="Visualizar"
                          placement="top"
                          followCursor
                          arrow
                        >
                          <Styles.Img
                            onClick={() => props.openModalEmails()}
                            width={20}
                            style={{ marginLeft: 30, cursor: "pointer" }}
                            src={icons.plusGreenIcon}
                          />
                        </Tooltip>
                      )}
                    </>
                  )}
                </div>
              </Styles.ContactArea>
            </div>
          </Styles.HeaderInfoLeft>
          <Styles.HeaderInfoRight>
            <AtualizadoBar
              farolAtualizacao={props.dataLead?.farolAtualizacao}
              dataUltimaAtualizacao={outputDate}
            />
            <SliderTemperature
              idLead={props?.dataLead?.idLead}
              idLeadCorretor={props?.dataLead?.idLeadCorretor}
              value={props.dataLead?.temperaturaLead}
              readOnly={props.readOnly}
            />
          </Styles.HeaderInfoRight>
        </Styles.HeaderInfo>
        <Styles.DadosCompContainer>
          <button type="button" onClick={() => setDadosComplementares(true)}>
            Visualizar dados complementares
          </button>
        </Styles.DadosCompContainer>
        <Styles.SectionHeader>
          <IoMdUndo
            color="#00000099"
            size={24}
            style={{
              margin: 0,
              transform: "scaleX(-1)",
            }}
          />
          Origem
        </Styles.SectionHeader>
        <Styles.FooterContainer>
          {dadosGerais?.map((item: DadosGeraisInterface) => (
            <Tooltip title={item.tooltip} placement="top" arrow>
              <div className="row">
                <p>{item.title}</p>
                <p>{item.outcome}</p>
              </div>
            </Tooltip>
          ))}
        </Styles.FooterContainer>
        <Styles.FooterLink type="button" onClick={props.openModalOrigem}>
          Ver histórico de origens
        </Styles.FooterLink>
      </Styles.Container>
      <DialogCommon
        closeText="Fechar"
        saveText="Salvar"
        onClose={() => setDadosComplementares}
        onSave={() => {}}
        isRight={false}
        onClean={() => {}}
        title="Dados complementares"
        isFilter={false}
        isClose
        width={800}
        height={520}
        component={
          <>
            <DadosComplementares
              idLeadCorretor={
                props?.dataLead?.idLeadCorretor
                  ? props?.dataLead?.idLeadCorretor
                  : ""
              }
              closeModal={() => setDadosComplementares(false)}
              readOnly={props.readOnly}
            />
          </>
        }
        setOpenModal={setDadosComplementares}
        open={dadosComplementares}
        icon={<IconsSVG.IdCardIcon />}
      />
      <DialogCommon
        closeText="Fechar"
        saveText="Salvar"
        onClose={() => setTagsOpen}
        onSave={() => {}}
        isRight={false}
        onClean={() => {}}
        titleHeader="Etiquetas"
        isFilter={false}
        isClose
        width={400}
        component={
          <TagEditor
            isOpen={tagsOpen}
            onClose={() => {
              setTagsOpen(false);
              setOpenEditing(undefined);
            }}
            tags={tags}
            refetch={() => {
              refetchEtiquetas();
              props.refetch();
            }}
            openEditing={openEditing}
          />
        }
        setOpenModal={setTagsOpen}
        open={tagsOpen}
        icon={
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "#819DFF",
              border: "8px solid #D5DEFF",
              padding: 2,
              borderRadius: "50%",
              height: 52,
              width: 52,
              marginRight: 12,
            }}
          >
            <LiaTagSolid color="white" size={24} style={{ margin: 0 }} />
          </div>
        }
      />
      <DialogCommon
        closeText="Cancelar"
        saveText="Sim"
        onClose={() => setConfirmEtiqueta(false)}
        onSave={() => {}}
        isRight={false}
        titleHeader="Tem certeza que deseja excluir?"
        isFilter={false}
        isClose
        width={400}
        component={
          <Styles.ConfirmContainer>
            <p>
              {
                "Ao excluir esta etiqueta, ela será removida de todos os Leads associados a ela."
              }
            </p>
            <div className="buttons">
              <button
                className="secondary"
                type="button"
                onClick={() => setConfirmEtiqueta(false)}
              >
                Cancelar
              </button>
              <button
                className="primary"
                type="button"
                onClick={() => {
                  handleChangeEtiqueta("");
                  setConfirmEtiqueta(false);
                }}
              >
                Sim
              </button>
            </div>
          </Styles.ConfirmContainer>
        }
        setOpenModal={setConfirmEtiqueta}
        open={confirmEtiqueta}
        icon={
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "#819DFF",
              border: "8px solid #D5DEFF",
              padding: 2,
              borderRadius: "50%",
              height: 52,
              width: 52,
              marginRight: 8,
            }}
          >
            <LiaTagSolid color="white" size={24} style={{ margin: 0 }} />
          </div>
        }
      />
    </>
  );
}
